export const pcpLiveFeatures = {
    /* enables private chat (askTeacher) between students and moderators */
    privateChats: false,
};
